import { isNumber } from 'lodash-es';

export const removeDataMinDataMax = (
  value: 'data-min' | 'data-max' | number | undefined,
) => (isNumber(value) ? value : undefined);
